
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Paginator from "../../../common/paginator/Paginator";
import Workshop from "../common/workshop/Workshop";
import { ProfileEmpty, ProfileSection, ProfileSectionError } from "../common/ProfileSection";

export default function WorkshopMineSection({ isDesktop, profileId }) {
	const [workshops, setWorkshops] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchWorkshops();
	}, []);

	useEffect(() => {
		fetchWorkshops();
	}, [page]);

	function fetchWorkshops() {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let pageParam = page ? page : 1;
		api.workshopListByProfile({
			token: LoginHelper.getToken(),
			profile_id: profileId,
			page: pageParam,
		})
			.then((result) => {
				setWorkshops(result["workshops"]);
				setMaxPageNum(result["max_page"]);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<ProfileSection title="کارگاه‌ها">
			{workshops.length >= 1 ? (
				<div className={`grid gap-4 ${isDesktop ? "grid-cols-3" : "grid-cols-1"}`}>
					{workshops.map((workshop) => (
						<Workshop key={workshop.id} workshop={workshop} />
					))}
				</div>
			) : (
				<ProfileEmpty>کارگاهی وجود ندارد</ProfileEmpty>
			)}
			{workshops.length >= 1 && maxPageNum >= 2 && (
				<div className="flex justify-center mt-5">
					<Paginator
						currentPage={page}
						maxPageNum={maxPageNum}
						isLoading={isLoading}
						onChange={(newPage) => {
							setPage(newPage);
						}}
					/>
				</div>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
